import { UntypedFormGroup } from "@angular/forms";

export const printFormValueAndValidity = (form: UntypedFormGroup) => {
  form.valueChanges.subscribe(() => {
    const controls = Object.keys(form.controls).map((k) => ({
      controlName: k,
      value: form.controls[k].value,
      valid: form.controls[k].valid,
    }));
    console.log(controls);
  });
};
